import React from 'react';
import TypoCss from "./typography.module.scss";
import styled from "styled-components";


function H1(props) {

  const H1style = styled.h1`
    font-size: 38px;
    line-height: 44px;
    margin-top: 20px;
  `;

  const { text } = props;

  return <H1style className={TypoCss.tbx_h1}>{text}</H1style>;
}

export default H1